import { Injectable } from "@angular/core";
import { RxState } from "@rx-angular/state";
import { DsrMultiBrandState } from "./dsr-multi-brand-state.interface";

@Injectable({
    providedIn: 'root'
})
export class DsrMultiBrandStore extends RxState<DsrMultiBrandState> {
    private readonly initState: DsrMultiBrandState = {
        loading: true,
        empty: false,
        brands: [],
    };

    constructor() {
        super();
        this.set({ ...this.initState });
    }
}
